const DOMAIN_LANGUAGES = {
    'localhost': 'nl',
    'oogst.app': 'nl',
    'oogst.local': 'nl',
    'gemusegartenplaner.de': 'de',
    'gemusegartenplaner.local': 'de',
    'recolte.app': 'fr',
    'recolte.local': 'fr',
    'plucking.app': 'en',
    'plucking.local': 'en',
    'plucking.testing.asyncforge.com': 'en',
};

const normalizeHostname = (hostname = '') => hostname.toLowerCase().replace(/^www\./, '');

export const getLanguageForHostname = (hostname) => {
    hostname = normalizeHostname(hostname);
    if (DOMAIN_LANGUAGES[hostname]) return DOMAIN_LANGUAGES[hostname];
    if (hostname === 'oogst.testing.asyncforge.com') return 'nl';
    return null;
};

export const getBrandNameForHostname = (hostname) => (
    getLanguageForHostname(hostname) === 'en' ? 'Plucking' : 'Oogst.app'
);

export const getApiBaseUrl = (hostname) => {
    hostname = normalizeHostname(hostname);
    if (hostname === 'plucking.testing.asyncforge.com') {
        return 'https://plucking-api.testing.asyncforge.com';
    }
    if (hostname.endsWith('.testing.asyncforge.com')) {
        return 'https://oogst-api.testing.asyncforge.com';
    }
    if (hostname === 'oogst-frontend.caprover.failfastfactory.io') {
        return 'https://oogst-api.caprover.failfastfactory.io';
    }
    if (hostname === 'localhost' || hostname.endsWith('.local')) {
        return 'http://localhost:8002';
    }
    return 'https://api.oogst.app';
};

export const getMarketForLocation = (hostname, search = '') => {
    hostname = normalizeHostname(hostname);
    if (['plucking.app', 'plucking.local', 'plucking.testing.asyncforge.com'].includes(hostname)) return 'US';
    return new URLSearchParams(search).get('market') === 'US' ? 'US' : 'EU';
};

export const getPublicBaseUrl = (hostname, language) => {
    hostname = normalizeHostname(hostname);
    if (hostname === 'plucking.testing.asyncforge.com') {
        return 'https://plucking.testing.asyncforge.com';
    }
    return {
        nl: 'https://oogst.app',
        de: 'https://gemusegartenplaner.de',
        fr: 'https://recolte.app',
        en: 'https://plucking.app',
    }[language] || 'https://oogst.app';
};
